import DOMPurify from "dompurify";

type DomPurifyLike = {
  sanitize?: (dirty: string, config?: unknown) => string;
  default?: {
    sanitize?: (dirty: string, config?: unknown) => string;
  };
};

export function escapeHtml(input: string): string {
  return input
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

export function sanitizeProductDescription(description: string): string {
  const domPurify = DOMPurify as unknown as DomPurifyLike;
  const sanitizeFn = domPurify.sanitize ?? domPurify.default?.sanitize;

  if (typeof sanitizeFn === "function") {
    return sanitizeFn(description, { USE_PROFILES: { html: true } });
  }

  return escapeHtml(description);
}
